import { render } from "./UnmappedComponent.vue?vue&type=template&id=04bf5988"
import script from "./UnmappedComponent.vue?vue&type=script&lang=js"
export * from "./UnmappedComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__